var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"slot":"activator","color":"white","small":"","fab":"","dark":""},nativeOn:{"click":function($event){return _vm.goToPage()}},slot:"activator"},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v(_vm._s(_vm.iconText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }